module.exports = __webpack_public_path__ + "static/images/lottery-box.2a370c0.png";